// Module
var code = `<label class="dropzone" data-bind="visible: enableUploading,
                                   css: {'drag-over': mouseOverDropZone},
                                   event: {dragenter: onDragEnter,
                                           dragover: onDragOver,
                                           dragleave: onDragLeave,
                                           drop: onDrop}">
    <input type="file" data-bind="attr: {multiple: !!multipleFiles()}, event: {change: onFileInputChange}">
    <span class="text-content" data-bind="text: translated('Click or Drop files here')"></span>
</label>
<table class="simple-table zebra-style" data-bind="visible: filesToShow().length">
    <thead>
        <tr>
            <th data-bind="text: translated('Name')"></th>
            <th class="txt-center" colspan="1" data-bind="text: translated('Size')"></th>
            <th class="txt-center" data-bind="text: translated('Uploaded')"></th>
            <th class="txt-center" data-bind="visible: enableUploading() || enableDeleting(), text: translated('Remove')"></th>
        </tr>
    </thead>
    <tbody data-bind="foreach: filesToShow">
        <tr>
            <td class="name">
                <!-- ko if: downloadHref -->
                <a class="subtle-link" target="_blank" data-bind="text: name, attr: {href: downloadHref, title: translated('Download document') + ': ' + name}"></a>
                <!-- /ko -->
                <!-- ko ifnot: downloadHref -->
                <span data-bind="text: name"></span>
                <!-- /ko -->
            </td>
            <td class="size nowrap" style="unicode-bidi: plaintext" data-bind="text: humanSize.string"></td>
            <td class="uploaded txt-center">
                <!-- ko if: state() === 'unsent' -->
                    <span data-bind="text: translated('waiting')"></span>
                <!-- /ko -->
                <!-- ko if: state() === 'uploading' -->
                    <ko-progress params="value: uploadProgress"></ko-progress>
                <!-- /ko -->
                <!-- ko if: state() === 'error' || state() === 'aborted' -->
                    <span class="error" data-bind="text: stateText"></span>
                <!-- /ko -->
                <!-- ko if: state() === 'uploaded' -->
                    <span data-bind="text: stateText, css: {success: stateText() === translated('OK')}"></span>
                <!-- /ko -->
                <!-- ko if: state() === 'removed' -->
                    <span class="success" data-bind="text: stateText"></span>
                <!-- /ko -->
            </td>
            <td class="remove txt-center" data-bind="visible: \$parent.enableUploading() || \$parent.enableDeleting()">
                <span class="icon_button icon_delete only_icon_img" data-bind="visible: canAbortUpload() || canDeleteFile(),
                                 click: \$parent.onRemove,
                                 attr: {title: translated('Remove') + ': ' + name}"></span>
            </td>
        </tr>
    </tbody>
</table>
`;
// Exports
export default code;